import { render, staticRenderFns } from "./configSelectSceneObject.vue?vue&type=template&id=5910b1f3&"
import script from "./configSelectSceneObject.vue?vue&type=script&lang=js&"
export * from "./configSelectSceneObject.vue?vue&type=script&lang=js&"
import style0 from "./configSelectSceneObject.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports